import React, { useState } from 'react';
import { Upload, message, Spin, Modal } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

type FileUploaderProps = {
    btnName: string;
    uploadUrl: string;
    resetFilters: any
};

const FileUploader: React.FC<FileUploaderProps> = ({ uploadUrl, btnName,
    resetFilters
}) => {
    const { t, i18n } = useTranslation('common');
    const currentLanguage = i18n.language

    const [uploading, setUploading] = useState<boolean>(false);

    const getToken = () => {
        return localStorage.getItem('accessToken');
    };

    const handleUpload = async (file: File) => {
        setUploading(true);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const { data } = await axios.post(uploadUrl, formData, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            resetFilters()
            message.success(data.message)
        } catch ({ response }: any) {
            message.error(response.data ? response.data.message : "error uploading file")
        } finally {
            setUploading(false);
        }
    };

    const customRequest = ({ file, onSuccess, onError }: any) => {
        setTimeout(() => {
            handleUpload(file);
            onSuccess();
        }, 0);
    };

    const beforeUpload = (file: File) => {
        const isExcelFile =
            file.type ===
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            file.type === 'application/vnd.ms-excel';

        if (!isExcelFile) {
            message.error('You can only upload Excel files!');
        }

        return isExcelFile;
    };

    return (
        <>
            <Upload
                customRequest={customRequest}
                showUploadList={false}
                beforeUpload={beforeUpload}
            >
                <div onClick={() => { }}>
                    <UploadOutlined style={{
                        color: '#1677FF', fontSize: '20px',
                        marginRight: currentLanguage === 'ar' ? '0px' : '15px',
                        marginLeft: currentLanguage === 'ar' ? '15px' : '0px'
                    }} />
                    {btnName}
                </div>
            </Upload>
            <Modal visible={uploading} title={t('uploading-file')} footer={null} closable={false} centered bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin size="large" />
            </Modal>
        </>
    );
};

export default FileUploader;
